export function initModal() {

  const modals = document.querySelectorAll('[data-modal]');
  if (!modals.length) return;

  let pendingDownload = null;

  const open = (id, downloadAfter) => {
    const target = document.getElementById(id);
    if (!target) return;
    pendingDownload = downloadAfter || null;
    target.classList.add('_active');
    document.body.classList.add('_modal-open');
  };

  const closeAll = () => {
    modals.forEach(m => {
      if (!m.classList.contains('_active')) return;
      m.classList.add('_out');
      setTimeout(() => {
        m.classList.remove('_active');
        m.classList.remove('_out');
      }, 250);
    });
    document.body.classList.remove('_modal-open');
  };

  document.addEventListener('click', (e) => {

    const opener = e.target.closest('[data-open-modal]');
    if (opener) {
      e.preventDefault();
      open(opener.dataset.openModal, opener.dataset.downloadAfter);
      return;
    }

    if (e.target.closest('[data-close-modal]')) {
      closeAll();
      pendingDownload = null;
    }

  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll();
      pendingDownload = null;
    }
  });

  // HubSpot form submission → trigger pending download
  window.addEventListener('message', (event) => {

    if (!event.data || event.data.type !== 'hsFormCallback') return;
    if (event.data.eventName !== 'onFormSubmitted') return;

    if (pendingDownload) {
      const url = pendingDownload;
      pendingDownload = null;

      setTimeout(() => {
        window.open(url, '_blank');
        closeAll();
      }, 800);
    }

  });

}
